<template>
  <div class="main">
    <Breadcrumb class="breadcrumb" separator=">">
      <BreadcrumbItem to="/">{{ $t("menu.home") }}</BreadcrumbItem>
      <BreadcrumbItem>{{ $t("hash.contractCode") }}</BreadcrumbItem>
    </Breadcrumb>
    <div class="info">
      <div class="tit">
        {{ $t("hash.codeAddress") }}: {{ addr }}
        <Tooltip :content="$t('copy')" placement="top">
          <i
            class="iconfont icon-fuzhi"
            v-clipboard:copy="addr"
            v-clipboard:success="copysuc"
            v-clipboard:error="copyerr"
          ></i>
        </Tooltip>
      </div>
      <div class="body">
        <table>
          <tr>
            <td>
              <span>{{ $t("hash.codeType") }}</span>
              <span>{{ info.contractType }}</span>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td>
              <span>{{ $t("hash.codeVersion") }}</span>
              <span>{{ info.contractVersion }}</span>
            </td>
          </tr>
        </table>
        <div class="beizhu">
          <div class="titt">{{ $t("hash.contractCode") }}</div>
        </div>

        <div>
          <div class="remark-body">
            <pre
              v-highlightjs="info.transformData"
              style="text-align: left; word-wrap: break-all"
            >
              <code :class="info.contractType">
              </code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  Tooltip,
} from "iview";
import api from "../common/api";
import { js_beautify } from "../common/lib/beautify.js";
export default {
  name: "ContractInfo",
  components: {
    Table,
    Button,
    Breadcrumb,
    BreadcrumbItem,
    Modal,
    Tooltip,
  },
  data() {
    return {
      loading: false,
      limit: 15,
      curpage: 1,
      marker: "",
      ismore: false,
      qr: false,
      addr: this.$route.params.codeAddress,
      logoSrc: require("../assets/images/logo.png"),
      choose: "",
      info: {},
    };
  },
  created() {
    this.getInfo();
  },
  watch: {
    "$route.query.codeAddress"() {
      this.marker = "";
      this.data = [];
      this.addr = this.$route.params.codeAddress;
    },
  },
  methods: {
    getInfo() {
      this.$axios(`${api.contractCodeDetail}?codeAddress=${this.addr}`)
        .then((res) => {
          this.info = res.data;
          if (res.data.contractCode) {
            this.info.transformData = res.data.contractCode.replace(
              /^(\s|\xA0)+|(\s|\xA0)+$/g,
              ""
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copysuc(e) {
      this.$Message.success(this.$t("copysuc"));
    },
    copyerr(e) {
      this.$Message.error(this.$t("copyerr"));
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/var.less";
.iconfont {
  font-size: 20px;
  cursor: pointer;
  color: @txtColor2;
  padding: 5px;
  &:hover {
    background: @mainbg;
    border-radius: 50%;
  }
}

.info {
  .box();
  margin: 20px 0;
  .tit {
    padding: 0 20px;
    background: #f5f5f5;
    line-height: 40px;
    font-weight: bold;
  }
  .body {
    // overflow: hidden;
    padding: 30px 20px 5px 20px;
    *zoom: 1;
    &:after {
      display: block;
      clear: both;
      content: "";
      visibility: hidden;
      height: 0;
    }

    table {
      width: 45%;
      float: left;
      &:nth-child(2) {
        margin-left: 10%;
      }
      tr {
        td {
          border-bottom: 1px solid #dfdfdf;
          line-height: 50px;
          overflow: hidden;
          span {
            // float: left;
            &:last-child {
              float: right;
            }
          }
          &.nobottom {
            border-bottom: none;
          }
        }
      }
    }
  }
}
.result {
  .box();
  padding: 20px;
  border-left: 2px solid @mainColor1;
  margin-bottom: 30px;
}
.remark-body {
  width: 100%;
  padding: 0 15px;
  background-color: #f8f9fb;
  border: none;
  resize: none;
  word-wrap: break-word;
  text-align: center;
  margin-top: 20px;
  textarea {
    outline: none;
    background-color: #f8f9fb;
    border: none;
    overflow: auto;
    height: 300px;
  }
}

.beizhu {
  box-sizing: border-box;
  padding: 0 5px;
  .titt {
    display: inline-block;
    width: 30%;
    margin-top: 20px;
  }
  .select {
    display: inline-block;
    width: 70%;
    text-align: right;
    .sel {
      width: 25%;
      text-align: center;
      .opt {
        text-align: left;
      }
    }
  }
}

pre {
  white-space: pre-wrap; /* css3.0 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  margin: 0;
  padding: 0;
}

.iconfont {
  color: #4da1ff;
}
</style>
